export default __webpack_public_path__ + "static/media/yamLogo.db1d2775.png";